import React from 'react';
import CheckPopUpBlockerFunction from './CheckPopUpBlockerFunction';
import { Link, useHistory } from 'react-router-dom';

export const FormLink = (props) => {
  const history = useHistory();

  const {
    dependentValues: {
      rowData,
      options: { url, formUrlFromFunction, onClick, editInNewTab, activeTabId = undefined, modal = false },
    },
    value,
    icon,
    column,
    location,
    match,
    tabIndex,
    title,
  } = props;

  const formUrl = formUrlFromFunction ? formUrlFromFunction(rowData) : url;

  const to = formUrl
    ? {
        pathname: `${formUrl}${value}`,
        state: {
          modal: modal,
          previousLocation: history.location?.pathname || 'back',
          activeTabId: activeTabId,
        },
      }
    : null;

  return (
    <Link
      to={to}
      target={editInNewTab ? '_blank' : undefined}
      rel={'noreferrer noopener'}
      column={column}
      history={history}
      location={location}
      match={match}
      tabIndex={tabIndex}
      title={title}
      onClick={(event) => {
        if (onClick) {
          onClick(value, rowData, event);
        }
      }}
    >
      {icon}
    </Link>
  );
};

export function formLinkHandleClick(
  { dispatch, history, formActiveTabId },
  { rowData, options: { url, formUrlFromFunction, entity, onClick, editInNewTab } }, //dependentValues
  value,
  readOnly
) {
  const formUrl = formUrlFromFunction ? formUrlFromFunction(rowData) : url;

  if (formUrl) {
    const targetUrl = formUrl + value;
    if (editInNewTab) {
      CheckPopUpBlockerFunction({ dispatch }, targetUrl, '_blank');
    } else {
      history.push({
        pathname: targetUrl,
        state: {
          modal: true,
          entity,
          popover: false,
          readOnly,
          previousLocation: history.location?.pathname || 'back',
          activeTabId: formActiveTabId,
        },
      });
    }
  } else if (onClick) {
    onClick(value, rowData);
  }
}
